import config from '@config';

import createDataSource from './createDataSource';
import { getDefaultEmptyList, getDefaultListHandler } from './utils';
import { FILE_KEY } from './constants';

const BASE_PATHNAME = 'stats-zone-users';

export default () => {
  const dataSource = createDataSource(config.api.url);
  const getById = ({ id }) => dataSource.get(`${BASE_PATHNAME}/${id}`).json();
  const create = ({ values }) => dataSource.post(BASE_PATHNAME, { json: { ...values } }).json();

  //const update = ({ id, values }) => dataSource.put(`${BASE_PATHNAME}`, { json: { id, ...values } }).json();

  const approve = ({ id }) => dataSource.post(`${BASE_PATHNAME}/${id}/approve`).json();

  const unapprove = ({ id }) => dataSource.post(`${BASE_PATHNAME}/${id}/disapprove`).json();


  const upload = ({ file }) => {
    const formData = new FormData();
    formData.append(FILE_KEY, file);

    return dataSource.post(`${BASE_PATHNAME}/upload`, { body: formData }).json();
  };

  return {
    getList: getDefaultListHandler({
      url: BASE_PATHNAME,
      dataSource,
      defaultFilters: { sort: 'email' },
    }),
    getById,
    create,
    approve,
    unapprove,
    upload,
    getEmptyList: getDefaultEmptyList,
  };
};
